import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import swal from 'sweetalert2';
import { CreateProjectService } from '../../../../../../shared/services/create-project/create-project.service';
import { ServiceProvidersService } from '../../../services/service-providers.service';

@Component({
  selector: 'app-select-analyst',
  templateUrl: './select-analyst.component.html',
  styleUrls: ['./select-analyst.component.css']
})
export class SelectAnalystComponent implements OnInit {

  @Input() selectedItemsList:any;
  @Output() unselectAnalyst: EventEmitter<any> = new EventEmitter<any>();
  userRole:string;
  constructor(private createProjectService: CreateProjectService,private router :Router,private authService:AuthenticationService,private serviceProviderService:ServiceProvidersService) { }

  ngOnInit() {
    this.userRole = this.authService.getFormattedRole();

  }

  public submitPartnerInfo() {
    this.createProjectService.setServiceProviderInfo(this.selectedItemsList);
    this.createProjectService.triggerPartnerAssignment();
    const selectedFilters = this.serviceProviderService.getSelectedFilters();
    if (this.selectedItemsList.length > 0 || (selectedFilters && selectedFilters.serviceId.length > 0 &&
      selectedFilters.marketId.length > 0 &&
      selectedFilters.industryId.length > 0 &&
      selectedFilters.focusAreaId.length > 0
    )) {
      this.router.navigate([`${this.userRole}/create-project/project-form`]);
    }
    else {
      swal('Info','Please select all filters or atleast one analyst.','info');
    }
  }

  public removeFromSelectedItems(deletedItemId) {
    
    this.unselectAnalyst.emit(deletedItemId);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/analyst-search/select-analyst/select-analyst.component.ts